export function createPrivateField<T extends {}, Q extends any = any>(
	initialValue?: Q,
) {
	const fields = new WeakMap<T, Q>()

	type getType = (sender: T) => Q
	type setType = (sender: T, value: any | ((value: Q) => Q)) => void

	const get = (sender: T): Q => {
		let value: any = initialValue
        if (Array.isArray(value)) {
			value = [...value]
		}else if (typeof value === "object") {
			value = { ...value }
		}
		if (!fields.has(sender)) {
			fields.set(sender, value)
		}
		return fields.get(sender) as Q
	}

	const set = (sender: T, value: any | ((value: Q) => Q)): void => {
		if (typeof value === "function") {
			fields.set(sender, value(get(sender)))
		} else {
			fields.set(sender, value)
		}
	}

	const out: [getType, setType] = [get, set]

	return out
}
